"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveMutedNotificationButton from "./wave-notification-settings/WaveMutedNotificationButton";
import WaveNotificationPreferenceButtons from "./wave-notification-settings/WaveNotificationPreferenceButtons";
import WaveNotificationRetryButton from "./wave-notification-settings/WaveNotificationRetryButton";
import { useWaveNotificationSettings } from "./wave-notification-settings/useWaveNotificationSettings";
interface WaveRatingProps {
  readonly wave: ApiWave;
}
export default function WaveNotificationSettings(t0) {
  const $ = _c(8);
  const {
    wave
  } = t0;
  const settings = useWaveNotificationSettings(wave);
  if (!settings.following) {
    return null;
  }
  if (settings.isMuted) {
    let t1;
    if ($[0] !== settings || $[1] !== wave.id) {
      t1 = <WaveMutedNotificationButton waveId={wave.id} settings={settings} />;
      $[0] = settings;
      $[1] = wave.id;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (settings.preferencesUnavailable) {
    let t1;
    if ($[3] !== settings) {
      t1 = <WaveNotificationRetryButton settings={settings} />;
      $[3] = settings;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== settings || $[6] !== wave.id) {
    t1 = <WaveNotificationPreferenceButtons waveId={wave.id} settings={settings} />;
    $[5] = settings;
    $[6] = wave.id;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}